import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage} from "react-intl";
import backImg from "../../assets/img/icon_back.svg";
import analyticsLogEvent from "../../services/FirebaseService";
import {FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import Spinner from "../../components/Spinner";
import {useNavigate} from "react-router";
import 'react-phone-number-input/style.css';
import 'react-phone-input-2/lib/style.css'
import {getPhoneVerificationCodeHandler, updateUserProfileHandler} from "../../handlers/HandlerUserProfile";
import {useParams} from "react-router-dom";


function PhoneUpdateEnterPin() {
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    let userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const inputRefs = useRef([]);
    const {phone} = useParams();
    const token = StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN) ? StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN) : null;
    const defaultCodeValue = Array(1).fill('');
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        phone: userInfo?.phone ? userInfo?.phone : null,
        confirmationCodeDefaultValue: defaultCodeValue,
        verificationCodeScreenIsVisible: false,
        gender: userInfo?.gender,
        isSubmitBtnEnabled: true,
        updatedAccountPopupStyle: hidden,
        verificationCodePopupStyle: hidden,
        verificationCodeInfoFromServer: null,
    });

    useEffect(() => {
         confirmPhoneNumber();
    }, [state.confirmationCodeDefaultValue]);


    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE
        });
    }, []);

    useEffect(() => {
        inputRefs.current = inputRefs.current.slice(0, state.confirmationCodeDefaultValue.length);
    }, [state.confirmationCodeDefaultValue.length]);



    const goBack = () => {
        navigateTo(-2);
    }



    const handleCodeChangeAndVerification = (e, index) => {
        const newCode = [...state.confirmationCodeDefaultValue];
        newCode[index] = e.target.value;
        setState((prevState) => ({
            ...prevState,
            confirmationCodeDefaultValue: newCode,
        }));
    }



    // Function to handle paste
    const handlePaste = async (e) => {
        e.preventDefault();

        const pastedText = e.clipboardData.getData('text/plain');

        if (/^\d+$/.test(pastedText)) {
            const pastedDigits = pastedText.split('');
            const newCode = [...state.confirmationCodeDefaultValue];

            for (let i = 0; i < newCode.length && i < pastedDigits.length; i++) {
                newCode[i] = pastedDigits[i];
            }

            setState({
                ...state,
                confirmationCodeDefaultValue: newCode,
            });

            // Adjust focus to the next input field
            const currentIndex = state.confirmationCodeDefaultValue.findIndex((digit) => digit === '');
            if (currentIndex !== -1) {
                const nextInput = document.getElementById(`input-${currentIndex + 1}`);
                if (nextInput) {
                    // Setting focus after a small delay to ensure correct behavior
                    setTimeout(() => {
                        nextInput.focus();
                    }, 50);
                }
            }
        }
    };


    const bodyForVerificationCodeRequest = {
        "email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
        "phone": phone,
        "locale":StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)
    }
    const resendCode = async () => {
            await getPhoneVerificationCodeHandler(bodyForVerificationCodeRequest).then(response => {
                if (response.ok) {
                    if (Object.keys(response.data).length === 0) {
                        setState({
                            ...state,
                            errorMsg: <FormattedMessage id="SmsShouldBeOnTheWay"
                                                        defaultMessage="SmsShouldBeOnTheWay"/>,
                        })
                    }else{
                        setState({
                            ...state,
                            errorMsg:null,
                            verificationCodeScreenIsVisible: true,
                            verificationCodeInfoFromServer: response.data,
                            verificationCodePopupStyle: visible,
                        })
                    }

                } else {
                    setState({
                        ...state,
                        errorMsg: <FormattedMessage id="VerificationIsTemporaryLocked"/>
                    })
                }

                setTimeout(function () {
                    setState(prevState => ({
                        ...prevState,
                        verificationCodePopupStyle: hidden,
                    }));
                }, 2000);
            })

    }


    const confirmPhoneNumber = async () => {
        if (!state.confirmationCodeDefaultValue || state.confirmationCodeDefaultValue.join("").length < 4) {
            return;
        }
        const body = {
            "email":StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "phone": phone,
            "code":state.confirmationCodeDefaultValue.join(""),
            "token":token
        }


        const response = await updateUserProfileHandler(body);
        if (response.ok) {
            userInfo = {
                ...userInfo,
                "phone": phone
            }
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_INFO, JSON.stringify(userInfo));
            setState({
                ...state,
                confirmationCodeDefaultValue: defaultCodeValue,
                updatedAccountPopupStyle: visible,
                loading: false,
                isSubmitBtnEnabled: false,
                errorMsg: null
            })

            setTimeout(function () {
                goBack();
            }, 2000);

        }  else if (response.data.code === 403) {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                errorMsg: <FormattedMessage id="InvalidVerificationCode"/>,
                loading: false,
                confirmationCodeDefaultValue: defaultCodeValue,
            })
        } else {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                errorMsg: <FormattedMessage id="InvalidVerificationCode"/>,
                loading: false,
                confirmationCodeDefaultValue: defaultCodeValue,
            })
        }
    }

    const handleOnKeyUp = (e, index) => {
        if (e.key === 'Backspace') {
            if (index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    }



    return (
        <div className="page-content without-actionsbar">
            <div className={state.updatedAccountPopupStyle + " modal-overlay always-invisible"}></div>
            <div className="modal confirmation-modal" data-qa="update-profile-success-modal">
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="YourPhoneNumberWasVerified"/></p>
                </div>
            </div>

            <div className={state.verificationCodePopupStyle + " modal-overlay always-invisible"}></div>
            <div className="modal confirmation-modal" data-qa="update-profile-success-modal">
                <div className="row">
                    <p className="modal-text"> <FormattedMessage id="CodeSentToPhone"
                                                                 values={{phoneNumber: phone}}/>
                    </p>
                </div>
            </div>


            <div className="login-container">
                <a className="btn-back" onClick={goBack} data-qa="update-profile-back-btn"><img alt="back button" src={backImg}/></a>

                    <div className="login-container-content text-left">
                        <div className="login-container-content-top-text">
                            <h3><FormattedMessage id="EnterConfirmationCode"/></h3>
                        </div>

                        <div className="confirmation-code-input-container">

                            <div className="title row">
                                <br/>
                                <FormattedMessage id="WeJustSentConfirmationCode"
                                                  values={{phoneNumber: phone}}/>
                            </div>

                            <div className="row">
                                {state.confirmationCodeDefaultValue.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="number"
                                        min="0"
                                        max="9"
                                        value={digit}
                                        onChange={(e) => handleCodeChangeAndVerification(e, index)}
                                        autoFocus={index === 0}
                                        ref={(input) => (inputRefs.current[index] = input)}
                                        readOnly={state.loading}
                                    />
                                ))}
                            </div>

                            {state.loading ?
                                <div className="spinner" data-qa="spinner"><Spinner/></div>
                                : null
                            }
                            {state.errorMsg != null ?
                                <>
                                    <div className="row">
                                        <div className="error-div" data-qa="update-profile-error-div">
                                            <p>&#9888;&nbsp;{state.errorMsg}</p>
                                        </div>
                                    </div>
                                </>
                                : null
                            }

                            <>
                                <div className="row tip">
                                    <p>
                                        <FormattedMessage
                                            id="WrongVerificationPhoneMessage"
                                            defaultMessage="WrongVerificationPhoneMessage"/>
                                    </p>
                                </div>
                                <div className="row">


                                    <a className="link underlined" onClick={() => resendCode()}><FormattedMessage
                                        id="ResendCode" defaultMessage="ResendCode"/></a>
                                </div>
                            </>


                        </div>


                    </div>

            </div>
        </div>

    );
}

export default PhoneUpdateEnterPin;
